import { BannerAlert, BannerAlertProps } from './banner/banner-alert';
import { DialogueAlert, DialogueAlertProps } from './dialogue/dialogue-alert';
import { MutedAlert, MutedAlertProps } from './muted/muted-alert';
import { ToastAlert, ToastAlertProps } from './toast/toast-alert';

type AlertType = React.FC & {
  Banner: React.FC<BannerAlertProps>;
  Toast: React.FC<ToastAlertProps>;
  Muted: React.FC<MutedAlertProps>;
  Dialogue: React.FC<DialogueAlertProps>;
};

export const Alert: AlertType = () => null;
Alert.Banner = BannerAlert;
Alert.Toast = ToastAlert;
Alert.Muted = MutedAlert;
Alert.Dialogue = DialogueAlert;

export type { AlertActionButton, AlertLink } from './alert-interface';
export { BannerAlertType } from './banner/banner-alert';
export type { BannerAlertProps } from './banner/banner-alert';
export type { ToastAlertProps } from './toast/toast-alert';
export type { MutedAlertProps } from './muted/muted-alert';
export { ErrorCode } from './alert-constants';
export type { DialogueAlertProps } from './dialogue/dialogue-alert';
